import API from '@/api'

// STATE
const state = {
  loading: false,
  articles: []
}

// GETTERS
const getters = {
  isLoading: state => state.loading,
  articles: state => state.articles
}

// ACTIONS
const actions = {
  fetchArticles ({ commit }, productId) {
    commit('toggleLoading')
    API.articles.index({
	  order_by : 'title',
      filter_attrs: { product_id: productId },
      take: -1
    }, articles => {
      commit('setArticles', articles)
      commit('toggleLoading')
    })
  }
}

// MUTATIONS
const mutations = {
  toggleLoading (state) {
    state.loading = !state.loading
  },
  setArticles (state, articles) {
    state.articles = articles
  },
  addArticle (state, article) {
    state.articles.push(article)
  },
  removeArticle (state, articleId) {
    const index = state.articles.findIndex(x => x.id === articleId)
    if (index > -1) {
      state.articles.splice(index, 1)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
